<template>
    <div style="width:100%; height: 100%; background-image: url('/img/bgd-banner.jpg')">
        <v-container>
            <v-card>
                <v-card-title dark class="white--text" style="background-color:#00aeef">
                    <v-btn icon @click.native="goBack()" class="mr-5">
                        <v-icon color="white">mdi-arrow-left</v-icon>
                    </v-btn>
                    Login
                </v-card-title>
                <form>
                    <v-layout row wrap px-10 py-4>
                        <v-flex xs12>
                            <v-text-field
                                v-model="email"
                                label="Email"
                                :counter="50"
                                :error-messages="errors.collect('Email')"
                                v-validate="'required|email'"
                                data-vv-name="Email"
                                class="requires--text"
                                data-cy="txtEmail"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex xs12>
                            <v-text-field
                                v-model="password"
                                label="Password"
                                type="password"
                                :counter="50"
                                :error-messages="errors.collect('Password')"
                                v-validate="'required|max:50|min:8'"
                                data-vv-name="Password"
                                class="requires--text"
                                data-cy="txtPassword"
                            ></v-text-field>
                        </v-flex>
                        <br />
                        <v-flex class="text-xs-center">
                            <v-btn @click="handleSubmit" color="hubblue" class="white--text" data-cy="btnLogin"
                                >Login</v-btn
                            >
                            <v-dialog v-model="resetPwDialog" persistent>
                                <template #activator="{ on }">
                                    <v-btn text small v-on="on">Can't log in?</v-btn>
                                </template>
                                <v-form @submit.prevent="onResetPwSubmit">
                                    <v-card>
                                        <v-card-title>
                                            <span>Reset Password</span>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click="resetPwDialog = false" :disabled="resetPwInProgress">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <div>
                                                Can't log in? If an email is associated with your account, enter it
                                                below to receive password reset instructions. If there is no email
                                                associated with your account, please contact your site administrator.
                                            </div>
                                            <v-text-field v-model="resetPwEmail" label="Email" required></v-text-field>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-btn
                                                type="submit"
                                                color="primary"
                                                :loading="resetPwInProgress"
                                                :disabled="resetPwInProgress"
                                                >Submit</v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-form>
                            </v-dialog>
                        </v-flex>
                    </v-layout>
                </form>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'
import { authHeader } from './_helpers'

export default {
    data() {
        return {
            email: '',
            password: '',
            submitted: false,
            resetPwDialog: false,
            resetPwEmail: '',
            resetPwInProgress: false
        }
    },
    computed: {
        loggingIn() {
            return this.$store.state.authentication.status.loggingIn
        }
    },
    created() {
        // reset login status
        this.$store.dispatch('authentication/logout')
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true
            const { email, password } = this
            const { dispatch } = this.$store
            if (email && password) {
                dispatch('authentication/login', { email, password })
            }
        },
        goBack() {
            this.$router.go(-1)
            this.email = ''
            this.password = ''
        },
        onResetPwSubmit() {
            this.resetPwInProgress = true
            axios
                .post(this.$store.state.resetPwRequestUrl, { email: this.resetPwEmail })
                .then(response => {
                    this.$store.commit('showSnackbar', {
                        message: response.data,
                        context: 'success'
                    })
                    this.resetPwEmail = ''
                    this.resetPwDialog = false
                })
                .catch(error => {
                    this.$store.commit('showSnackbar', {
                        message: error.response ? error.response.data : 'Network error',
                        context: 'error'
                    })
                })
                .finally(() => {
                    this.resetPwInProgress = false
                })
        }
    }
}
</script>
